// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_TEAM_MASTER_REQUEST = 'FETCH_TEAM_MASTER_REQUEST';
export const FETCH_TEAM_MASTER_SUCCESS = 'FETCH_TEAM_MASTER_SUCCESS';
export const FETCH_TEAM_MASTER_FAILURE = 'FETCH_TEAM_MASTER_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_TEAM_MASTER_COMPANY_LIST_REQUEST = 'FETCH_TEAM_MASTER_COMPANY_LIST_REQUEST';
export const FETCH_TEAM_MASTER_COMPANY_LIST_SUCCESS = 'FETCH_TEAM_MASTER_COMPANY_LIST_SUCCESS';
export const FETCH_TEAM_MASTER_COMPANY_LIST_FAILURE = 'FETCH_TEAM_MASTER_COMPANY_LIST_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_TEAM_MASTER_TEAM_LEAD_REQUEST = 'FETCH_TEAM_MASTER_TEAM_LEAD_REQUEST';
export const FETCH_TEAM_MASTER_TEAM_LEAD_SUCCESS = 'FETCH_TEAM_MASTER_TEAM_LEAD_SUCCESS';
export const FETCH_TEAM_MASTER_TEAM_LEAD_FAILURE = 'FETCH_TEAM_MASTER_TEAM_LEAD_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_TEAM_MASTER_REQUEST = 'CREATE_TEAM_MASTER_REQUEST';
export const CREATE_TEAM_MASTER_SUCCESS = 'CREATE_TEAM_MASTER_SUCCESS';
export const CREATE_TEAM_MASTER_FAILURE = 'CREATE_TEAM_MASTER_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_TEAM_MASTER = 'CREATE_USER_FORM_TEAM_MASTER';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_TEAM_MASTER_REQUEST = 'UPDATE_TEAM_MASTER_REQUEST';
export const UPDATE_TEAM_MASTER_SUCCESS = 'UPDATE_TEAM_MASTER_SUCCESS';
export const UPDATE_TEAM_MASTER_FAILURE = 'UPDATE_TEAM_MASTER_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_TEAM_MASTER_REQUEST = 'FETCH_SINGLE_TEAM_MASTER_REQUEST';
export const FETCH_SINGLE_TEAM_MASTER_SUCCESS = 'FETCH_SINGLE_TEAM_MASTER_SUCCESS';
export const FETCH_SINGLE_TEAM_MASTER_FAILURE = 'FETCH_SINGLE_TEAM_MASTER_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_TEAM_MASTER_REQUEST = 'DELETE_TEAM_MASTER_REQUEST';
export const DELETE_TEAM_MASTER_SUCCESS = 'DELETE_TEAM_MASTER_SUCCESS';
export const DELETE_TEAM_MASTER_FAILURE = 'DELETE_TEAM_MASTER_FAILURE';

// USERFORM RESET

export const TEAM_MASTER_USERFORM_RESET = 'TEAM_MASTER_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_TEAM_DETAILS = 'NAVIGATE_TEAM_DETAILS';
// navigate to company component
export const NAVIGATE_TEAM_MASTER = 'NAVIGATE_TEAM_MASTER';
